var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "settings mb-0 border" }, [
    _c(
      "div",
      { staticClass: "container-fluid px-0 d-flex flex-column w-100 h-100" },
      [
        _c(
          "div",
          {
            staticClass: "d-flex justify-content-center board-column-move",
            on: {
              mousedown: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c("div", { staticClass: "move-left-empty py-2 pl-2 pr-3" }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-inline clickable move move-left",
                on: {
                  mousedown: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleMove(_vm.DIR_LEFT)
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "fa fa-angle-left py-2 pl-2 pr-3 text-primary",
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-row align-items-center justify-content-center w-100",
              },
              [_c("i", [_vm._v(_vm._s(_vm.$t("boards.actions.moveStatus")))])]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "move-right-empty py-2 pl-3 pr-2" }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-inline clickable move move-right",
                on: {
                  mousedown: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleMove(_vm.DIR_RIGHT)
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "fa fa-angle-right py-2 pl-3 pr-2 text-primary",
                }),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("hr", { staticClass: "w-100 mt-2" }),
        _vm._v(" "),
        _c("div", { staticClass: "row no-gutters pb-2" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("p", { staticClass: "m-0 small" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.$t("boards.actions.muteNotificationsToSubscribers")
                  ) +
                  "\n          "
              ),
              _c("i", {
                staticClass: "ml-2 fa fa-info-circle text-gray",
                attrs: {
                  "aria-hidden": "true",
                  "data-toggle": "tooltip",
                  "data-placement": "top",
                  "data-original-title": _vm.$t(
                    "boards.messages.subscribersWillNotReceiveRmailNotifications"
                  ),
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 mt-2" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-left align-items-center h-100",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "pretty p-switch p-fill d-flex justify-content-center align-items-center",
                  },
                  [
                    _c(
                      "label",
                      { staticClass: "text-light-gray label-before mb-0 mr-2" },
                      [_vm._v(_vm._s(_vm.$t("global.words.no")))]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.muteNotificationsLocal,
                          expression: "muteNotificationsLocal",
                        },
                      ],
                      staticStyle: { left: "22px" },
                      attrs: {
                        id:
                          _vm.$t(
                            "boards.messages.subscribersWillNotReceiveRmailNotifications"
                          ) + _vm.title,
                        name: "muteNotifications",
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.muteNotificationsLocal)
                          ? _vm._i(_vm.muteNotificationsLocal, null) > -1
                          : _vm.muteNotificationsLocal,
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$a = _vm.muteNotificationsLocal,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.muteNotificationsLocal = $$a.concat([
                                    $$v,
                                  ]))
                              } else {
                                $$i > -1 &&
                                  (_vm.muteNotificationsLocal = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.muteNotificationsLocal = $$c
                            }
                          },
                          _vm.handleChange,
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "hidden-text",
                        attrs: {
                          for:
                            _vm.$t(
                              "boards.messages.subscribersWillNotReceiveRmailNotifications"
                            ) + _vm.title,
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("global.words.switch")))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "state" }, [
                      _c("label", { staticClass: "ml-1" }, [
                        _vm._v(_vm._s(_vm.$t("global.words.yes"))),
                      ]),
                    ]),
                  ]
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row no-gutters mt-2 pt-3 pb-2" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("p", { staticClass: "m-0 small" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.$t("boards.actions.muteAutomationsForThisStatus")
                  ) +
                  "\n          "
              ),
              _c("i", {
                staticClass: "ml-2 fa fa-info-circle text-gray",
                attrs: {
                  "aria-hidden": "true",
                  "data-toggle": "tooltip",
                  "data-placement": "top",
                  "data-original-title": _vm.$t(
                    "boards.messages.automationsWillNotBeTriggered"
                  ),
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 mt-2" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-left align-items-center h-100",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "pretty p-switch p-fill d-flex justify-content-center align-items-center",
                  },
                  [
                    _c(
                      "label",
                      { staticClass: "text-light-gray label-before mb-0 mr-2" },
                      [_vm._v(_vm._s(_vm.$t("global.words.no")))]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.muteAutomationsLocal,
                          expression: "muteAutomationsLocal",
                        },
                      ],
                      staticStyle: { left: "22px" },
                      attrs: {
                        id:
                          _vm.$t(
                            "boards.actions.muteAutomationsForThisStatus"
                          ) + _vm.title,
                        name: "muteAutomations",
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.muteAutomationsLocal)
                          ? _vm._i(_vm.muteAutomationsLocal, null) > -1
                          : _vm.muteAutomationsLocal,
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$a = _vm.muteAutomationsLocal,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.muteAutomationsLocal = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.muteAutomationsLocal = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.muteAutomationsLocal = $$c
                            }
                          },
                          _vm.handleChange,
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "hidden-text",
                        attrs: {
                          for:
                            _vm.$t(
                              "boards.actions.muteAutomationsForThisStatus"
                            ) + _vm.title,
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("global.words.switch")))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "state" }, [
                      _c("label", { staticClass: "ml-1" }, [
                        _vm._v(_vm._s(_vm.$t("global.words.yes"))),
                      ]),
                    ]),
                  ]
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row no-gutters mt-2 pt-3 pb-2" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("p", { staticClass: "m-0 small" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("boards.actions.idleShading")) +
                  "\n          "
              ),
              _c("i", {
                staticClass: "ml-2 fa fa-info-circle text-gray",
                attrs: {
                  "aria-hidden": "true",
                  "data-toggle": "tooltip",
                  "data-placement": "top",
                  "data-original-title": _vm.$t(
                    "boards.messages.clientCardWillBeShaded"
                  ),
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "setting col-12 mt-2" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-left align-items-center h-100",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "pretty p-switch p-fill d-flex justify-content-center align-items-center toggle-rotting-threshold",
                  },
                  [
                    _c(
                      "label",
                      { staticClass: "text-light-gray label-before mb-0 mr-2" },
                      [_vm._v(_vm._s(_vm.$t("global.words.no")))]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.includeRottingDaysThreshold,
                          expression: "includeRottingDaysThreshold",
                        },
                      ],
                      staticClass: "rotting-threshold-input-toggle",
                      staticStyle: { left: "22px" },
                      attrs: {
                        id: _vm.$t("boards.actions.idleShading") + _vm.title,
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.includeRottingDaysThreshold)
                          ? _vm._i(_vm.includeRottingDaysThreshold, null) > -1
                          : _vm.includeRottingDaysThreshold,
                      },
                      on: {
                        input: _vm.handleChange,
                        change: function ($event) {
                          var $$a = _vm.includeRottingDaysThreshold,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.includeRottingDaysThreshold = $$a.concat([
                                  $$v,
                                ]))
                            } else {
                              $$i > -1 &&
                                (_vm.includeRottingDaysThreshold = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.includeRottingDaysThreshold = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "hidden-text",
                        attrs: {
                          for: _vm.$t("boards.actions.idleShading") + _vm.title,
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("global.words.switch")))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "state" }, [
                      _c("label", { staticClass: "ml-1" }, [
                        _vm._v(_vm._s(_vm.$t("global.words.yes"))),
                      ]),
                    ]),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.includeRottingDaysThreshold
            ? _c(
                "div",
                {
                  staticClass: "setting col-12 mt-2 rotting-threshold-input",
                  on: {
                    mousedown: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-left align-items-center h-100",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-center align-items-center w-50",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "form-group-material mb-0" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.rottingDaysThresholdLocal,
                                    expression: "rottingDaysThresholdLocal",
                                  },
                                ],
                                ref: "rottingDaysInput",
                                staticClass:
                                  "material-input form-control form form-control-filled",
                                attrs: {
                                  id: "idle-shading-days",
                                  name: "rottingDaysThreshold",
                                  type: "number",
                                  min: "1",
                                  pattern: "[1-9][0-9]*",
                                },
                                domProps: {
                                  value: _vm.rottingDaysThresholdLocal,
                                },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.rottingDaysThresholdLocal =
                                        $event.target.value
                                    },
                                    _vm.handleChange,
                                  ],
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "title text-light-gray mb-2 mb-lg-0",
                                  attrs: { for: "idle-shading-days" },
                                },
                                [_vm._v(_vm._s(_vm.$tc("global.words.day", 2)))]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row no-gutters mt-2 pt-3 pb-2" }, [
          _c(
            "div",
            { staticClass: "col-12 d-flex flex-row align-items-center" },
            [
              _c("p", { staticClass: "m-0 small" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("boards.actions.moveClientsToAnotherBoard")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              !_vm.columnHaveClients
                ? _c("icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.left",
                        value: {
                          title: _vm.$t("boards.messages.noClientsToMove"),
                          disabled: _vm.columnHaveClients,
                        },
                        expression:
                          "{\n            title: $t('boards.messages.noClientsToMove'),\n            disabled: columnHaveClients\n          }",
                        modifiers: { left: true },
                      },
                    ],
                    staticClass: "text-grey ml-1 cursor-auto",
                    attrs: { name: "info-circle" },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 mt-2" },
            [
              _c(
                "material-input",
                {
                  attrs: {
                    id: "boards-select-" + _vm.statusId,
                    disabled: !_vm.columnHaveClients,
                  },
                  model: {
                    value: _vm.toBoardId,
                    callback: function ($$v) {
                      _vm.toBoardId = $$v
                    },
                    expression: "toBoardId",
                  },
                },
                [
                  _c("board-select", {
                    ref: "selectBoard",
                    attrs: {
                      id: "boards-select-" + _vm.statusId,
                      multiple: false,
                      value: _vm.toBoardId,
                      "material-design": false,
                      options: {
                        placeholder: _vm.$t("boards.actions.selectABoard"),
                      },
                      "form-group-class": "mb-0",
                      "space-classes": "col-12 p-0 mt-0",
                    },
                    on: { change: _vm.handleBoardChange },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover.title",
                  value: {
                    id: "statuses-select-tooltip",
                    title: _vm.$t("global.phrases.loadingYourExperience"),
                    disabled: !_vm.loadingStatuses,
                  },
                  expression:
                    "{\n          id: 'statuses-select-tooltip',\n          title: $t('global.phrases.loadingYourExperience'),\n          disabled: !loadingStatuses\n        }",
                  modifiers: { hover: true, title: true },
                },
              ],
              staticClass: "col-12 mt-2",
            },
            [
              _c(
                "material-input",
                {
                  attrs: {
                    id: "status-select-" + _vm.statusId,
                    disabled: !_vm.toBoardId || !_vm.columnHaveClients,
                  },
                  model: {
                    value: _vm.toStatusLabelId,
                    callback: function ($$v) {
                      _vm.toStatusLabelId = $$v
                    },
                    expression: "toStatusLabelId",
                  },
                },
                [
                  _c("select2", {
                    ref: "select",
                    attrs: {
                      data: _vm.selectedToBoardStatuses,
                      value: _vm.toStatusLabelId,
                      name: "definition-type",
                      options: {
                        placeholder: _vm.$t("boards.actions.selectAStatus"),
                      },
                      "format-data": _vm.formatData,
                    },
                    on: { change: _vm.handleStatusChange },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 mt-2 d-flex justify-content-end" },
            [
              _c(
                "simple-button",
                {
                  attrs: {
                    "class-name": "btn-sm",
                    disabled: _vm.disabledMove,
                    loading: _vm.moveClients.loading,
                    "loading-succeeded": _vm.moveClients.succeeded,
                  },
                  on: { click: _vm.handleMoveClients },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$tc("boards.actions.moveClient", 2)) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { "flex-grow": "1" } }),
        _vm._v(" "),
        !_vm.isFirstColumn
          ? _c(
              "inline-prompt",
              {
                ref: "prompt",
                staticClass: "bold text-gray clickable",
                attrs: { "action-type": "delete" },
                on: { accept: _vm.handleDelete },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "preConfirmationContent",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "text-gray mb-2" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t("boards.messages.removingStatus")
                                ) +
                                "\n          "
                            ),
                            _c("span", { staticClass: "bold" }, [
                              _vm._v(" " + _vm._s(_vm.firstColumnLabel)),
                            ]),
                            _vm._v(".\n        "),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2967739081
                ),
              },
              [
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "remove-state-column d-flex flex-row align-items-center pt-1 pb-2",
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "add-client-profile bold text-gray w-100 truncate",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("boards.actions.removeStatus"))
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("i", { staticClass: "fa fa-trash text-danger" }),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }